// services/studentAuthApiClient.js
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === "production" 
  ? 'https://backend.successtutorial.org' 
  : 'http://localhost:5000';

const studentAuthApiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Response interceptor for token refresh
studentAuthApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Don't retry on login/logout endpoints
    if (originalRequest.url.includes('/students/login') || 
        originalRequest.url.includes('/students/logout')) {
      return Promise.reject(error);
    }

    // Handle 401 - Try to refresh token
    if (error.response?.status === 401 && 
        !originalRequest._retry) {
      
      // Don't retry for check-auth endpoint
      if (originalRequest.url.includes('/check-auth')) {
        return Promise.reject(error);
      }
      
      if (isRefreshing) {
        // Wait for refresh to complete
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => {
            return studentAuthApiClient(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        console.log('🔄 Attempting student token refresh...');
        
        // Try to refresh token
        await studentAuthApiClient.post('/api/students/refresh-token');
        
        console.log('✅ Student token refresh successful');
        processQueue(null);
        
        // Retry the original request
        return studentAuthApiClient(originalRequest);
        
      } catch (refreshError) {
        console.log('❌ Student token refresh failed');
        
        // Refresh failed - process queue with error
        processQueue(refreshError, null);
        
        // Only redirect if not already on login page
        if (!window.location.pathname.includes('students-login')) {
          window.location.href = '/students-login?session=expired';
        }
        
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    return Promise.reject(error);
  }
);

export { studentAuthApiClient };